



































































import { Component, Vue, Mixins, Prop } from 'vue-property-decorator';
import UserMixin from '@/mixins/UserMixin';
import EditViewMixin from '@/mixins/EditViewMixin';
import DeviceViewMixin from '@/mixins/DeviceViewMixin';
import PromiseLoaderMixin from '@/mixins/PromiseLoaderMixin';

import TopMenu from '@/components/TopMenu.vue';
import FooterMenu from '@/components/FooterMenu.vue';
import TilesPicker from '@/components/TilesPicker.vue';
import SoftwareUpdateAvailableIcon from '@/components/SoftwareUpdateAvailableIcon.vue';

import { State, Getter, Action, Mutation } from 'vuex-class';
import { IN2kOnDevice, IN2kState } from '../../store/n2k/types';
import { ITilesViewPage } from '../../store/views/tilesView/types';
import TileComponents from '@/components/tiles/index';

@Component({
    components: {
        TopMenu,
        FooterMenu,
        TilesPicker,
        SoftwareUpdateAvailableIcon,
        ...TileComponents,
    },
})
export default class Tiles extends Mixins(UserMixin, EditViewMixin, DeviceViewMixin, PromiseLoaderMixin) {

    public loading: boolean = true;

    @State('n2k')
    public n2kData?: IN2kState;

    public get pages(): ITilesViewPage[] {
        if (!this.deviceNumber) {
            return [];
        }
        return this.getPages(this.deviceNumber);
    }

    public pageNumber: number = 0;


    @Mutation('tilesView/addOrUpdateTile')
    private viewAddOrUpdateTile: (args: {deviceNumber: string, page: number, index: number | null, type: string, configuration: any}) => void;

    @Mutation('tilesView/moveUp')
    private viewMoveUp: (args: {deviceNumber: string, page: number, index: number}) => void;

    @Mutation('tilesView/moveDown')
    private viewMoveDown: (args: {deviceNumber: string, page: number, index: number}) => void;

    @Mutation('tilesView/delete')
    private viewDelete: (args: {deviceNumber: string, page: number, index: number}) => void;

    @Getter('tilesView/pages')
    private getPages: (deviceNumber: string) => ITilesViewPage[];

    public tileExists(type: string): boolean {
        for (const key in TileComponents) {
            if (key === type) {
                return true;
            }
        }
        return false;
    }

    public async mounted() {
        // this.isEditing = true;
        if (!this.verifyLoginStatus(true)) {
            return;
        }
        await this.loadPromises([
            {name: 'tilesView/load', promise: () => this.$store.dispatch('tilesView/load', { deviceNumber: this.deviceNumber })},
            {name: 'relaysView/load', promise: () => this.$store.dispatch('relaysView/load', { deviceNumber: this.deviceNumber })},
            {name: 'relays/load', promise: () => this.$store.dispatch('relays/load', { deviceNumber: this.deviceNumber })},
        ]);
        this.loading = false;
    }

    public moveTileUp(page: number, index: number) {
        if (this.viewMoveUp && this.deviceNumber) {
            this.viewMoveUp({
                deviceNumber: this.deviceNumber,
                page,
                index,
            });
        }
    }
    public moveTileDown(page: number, index: number) {
        if (this.viewMoveDown && this.deviceNumber) {
            this.viewMoveDown({
                deviceNumber: this.deviceNumber,
                page,
                index,
            });
        }
    }
    public deleteTile(page: number, index: number) {
        if (this.viewDelete && this.deviceNumber) {
            this.viewDelete({
                deviceNumber: this.deviceNumber,
                page,
                index,
            });
        }
    }

    public async tileSave(page: number, index: number | null, evt: { type: string, configuration: any}) {
        this.viewAddOrUpdateTile({
            deviceNumber: this.deviceNumber,
            page: 0,
            index,
            type: evt.type,
            configuration: evt.configuration,
        });
    }

    public async undoEdititing() {
        this.loading = true;
        await this.$store.dispatch('tilesView/load', { deviceNumber: this.deviceNumber });
        this.loading = false;
        this.isEditing = false;
    }
    public async saveEditing(): Promise<any> {
        this.loading = true;

        try {
            const promises: Array<Promise<any>> = [];
            await this.$store.dispatch('tilesView/pushToViews', {deviceNumber: this.deviceNumber});
            await this.$store.dispatch('views/upload', {deviceNumber: this.deviceNumber});

            this.loading = false;
            this.isEditing = false;
        } catch (e) {
            this.loading = false;
        }
    }

}
